import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  TextField,
  ThemeProvider,
  createMuiTheme,
  IconButton,
  Grid,
  Typography,
  TableContainer,
  Select,
  InputLabel,
  MenuItem,
  Tooltip,
  DialogTitle,
  Dialog,
  DialogContent,
  CircularProgressProps,
  CircularProgress,
  Box,
  DialogActions,
  FormControl
} from "@material-ui/core";
import useStyles from "./css/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Context, SupportFile } from "./store";
import { GetDocumentCategories, UploadDocuments, InsertPELogs, GetAdminSettingValue } from "./api"; // FB 4960 FB 10815
import { useHistory } from "react-router";
import globalsettings from "../../config"; //FB 4960


//Update log
// FB 4867 DK   12/27/2021    Added for Support files upload
// FB 4955 DK   02/15/2022    UI enhancements for Mobile Version
// FB 4960 BR   07/03/2022    Logging all actions on PE
// FB 6025 BR   04/26/2022    PE - Import Photos through QR code scan from smartphone
// FB 8666 GA   05/16/2024    Replace SQL Job for Moving Uploaded Files to Specific EMR Categories with EMR SW Which Moves the Uploaded Files Upon Receipt
// FB 9672 DK   11/15/2024    Auto scroll not working properly from iphone mini
// FB 9671 DK   11/29/2024    "take photo" option needs to allow multiple photos to be taken
// FB 10815 GA   08/01/2025    Admin setting for PE/Portal upload document screen
// FB 11093 BH   10/29/2025    PE Book an appointment issue



function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number },
) {
  return (
    <Box style={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" style={{ color: "#18a2b8" }} {...props} />
      <Box
        style={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* <Typography
          variant="caption"
          component="div"
          style={{ color: "#18a2b8" }}
        >{`${Math.round(props.value)}%`}</Typography> */}
      </Box>
    </Box>
  );
}

function Upload(props: any) {
  const [documentCategories, setDocumentCategories] = useState<string[]>([]);//FB 11093

  const [documentType, setDocumentType] = useState<any>("");
  const [otherDocument, setOtherDocument] = useState<any>("");
  const [inputList, setInputList] = useState<SupportFile[]>([]);
  const { state } = useContext(Context);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [progress, setProgress] = React.useState(10);
  const [buttonLabel, setButtonLabel] = useState("Cancel");
  //FB 10815
  const [uploadDocumentText, setUploadDocumentText] = useState<string>("To reduce your time in the office, Please upload documents to your electronic chart including: Your driver's license, Insurance card or Any important medical documents such as Lab results, Pathology reports, Relevant images.");
  const styles = useStyles();
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
    overrides: {
      MuiFormLabel: {
        asterisk: {
          color: 'red',
        }
      }
    }
  });
  var JSAlert = require("js-alert");
  //const [DocumentCategories, setDocumentCategories] = useState([]);//FB 11093 commented this line

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  React.useEffect(() => {
    inputList.length > 0 ? setDisableSubmit(false) : setDisableSubmit(true);
  }, [inputList])
  
  // FB 6025
  const useSmartphoneClick = async () => {
    var encodedAppt_n = Buffer.from(props.match.params.apptId).toString('base64');
    var encodedDocType = Buffer.from(documentType).toString('base64');
    var decodedAppt_n = Buffer.from(props.match.params.apptId, "base64").toString();
    InsertPELogs(globalsettings.clientIp, "Clicked on Use Smartphone - Upload files");
    setDocumentType("");
    window.open("/appointment/Importphotos/" + encodedAppt_n + "/" + encodedDocType)
  }


  //FB 9671 Start
  const addInputDocument = (e: any) => {
    for (let i = 0; i < e.target.files.length; i++) {
      const file = e.target.files[i];
      const fileSize = Number((file.size / (1024 * 1024)).toFixed(3));
      if ((file.type === "application/pdf" || file.type === "image/png" || file.type === "image/jpeg") && fileSize > 0) {
        if (fileSize <= 6) {
          const reader = new FileReader();
          var decodedAppt_n = Buffer.from(props.match.params.apptId, "base64").toString();
          //FB 4960 Start
          InsertPELogs(globalsettings.clientIp, "Clicked on Choose file(s) - Upload files");
          //FB 4960 End
          reader.onload = () => {
            const input = {
              DocumentType: documentType,
              OtherDocument: otherDocument,
              FileName: file.name,
              FileType: file.type,
              FileSize: fileSize,
              Base64EncodedFile: reader.result?.toString().split("base64,")[1],
              Appointment_N: Number(decodedAppt_n)
            } as SupportFile;
            inputList.push(input);
            setDocumentType("");
            setOtherDocument("");
            setButtonLabel("Cancel");
            setDisableSubmit(false);
          };
          reader.readAsDataURL(file);
        }
        else {
          JSAlert.alert("Please select a file smaller than 6MB", null, JSAlert.Icons.Warning);
        }
      }
      else {
        JSAlert.alert("Invalid file type. Please select a valid file", null, JSAlert.Icons.Warning);
      }
    }
  };
  //FB 9671 End

  // handle click event of the Remove button
  const handleRemoveClick = (index: number) => {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Delete - Upload files");
    //FB 4960 End
    var alert = new JSAlert("Are you sure you want to delete this file?", "", JSAlert.Icons.Question);
    alert.addButton("Yes").then(function () {
      inputList.splice(index, 1);
      setInputList([...inputList]);
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Clicked on yes - Upload files");
      //FB 4960 End
    });
    alert.addButton("No").then(function () {
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Clicked on no - Upload files");
      //FB 4960 End
      return;
    });
    alert.show();
  };

  const submitDocuments = async () => {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Upload to my chart - Upload files");
    //FB 4960 End
    var decodedAppt_n = Buffer.from(props.match.params.apptId, "base64").toString();
    setDisableSubmit(true);
    setOpenDialog(true);
    const result = await UploadDocuments(inputList, Number(decodedAppt_n));
    if (result === 200) {
      setOpenDialog(false);
      JSAlert.alert("File(s) uploaded successfully!", null, JSAlert.Icons.Success);
      setButtonLabel("Done");
      setInputList([])
      // .then(function () {
      //   window.location.href = "/closure";
      // });
    }
    else {
      setOpenDialog(false);
      setDisableSubmit(false);
      setButtonLabel("Cancel");
    }
  }
  const history = useHistory();

  const handleDone = () => {
    //FB 4960 Start
    if (buttonLabel == "Cancel") {
      InsertPELogs(globalsettings.clientIp, "Clicked on Cancel - Upload files");
    }
    else if (buttonLabel == "Done") {
      InsertPELogs(globalsettings.clientIp, "Clicked on Done - Upload files");
    }
    //FB 4960 End
    history.replace("/closure", { origin: "upload" });
  }
    //FB 10815
    async function GetUploadDocumentText() {
        var data = await GetAdminSettingValue("upload_document_screen_text");
        if (data != null && data != "") {
            setUploadDocumentText(data);
        } else {
            console.log("Admin setting is null/empty, using default text");
        }
  }
  //FB 11093 removed below line
  // useEffect(() => {
  //   //FB-8666 Begin
  //   GetDocumentCategories().then((data) => { 
  //     var labels = data.split(",").map((label: string) => label.includes(':') ? label.split(':')[0] : label);
  //     setDocumentCategories(labels);
  //   });
  //   //FB 8666 End
  //   GetUploadDocumentText();//FB 10815
  // }, []);
  
//FB 11093 Begin
useEffect(() => {
  //FB-8666 Begin
  GetDocumentCategories().then((data) => {
    if (typeof data === "string") {
      const labels = data
        .split(",")
        .map((label: string) =>
          label.includes(":") ? label.split(":")[0].trim() : label.trim()
        );
      setDocumentCategories(labels);
    } 
    else if (Array.isArray(data)) {
      setDocumentCategories(data);
    } 
    else if (data && typeof data === "object" && data.DocumentCategories) {
     
      const labels = data.DocumentCategories
        .split(",")
        .map((label: string) =>
          label.includes(":") ? label.split(":")[0].trim() : label.trim()
        );
      setDocumentCategories(labels);
    } 
    else {
      setDocumentCategories([]);
    }
  });
  //FB 8666 End
  GetUploadDocumentText();//FB 10815
}, []);
//FB 11093 End



  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  //FB 4960
  const SelectDocumentType = async (e: any) => {
    setDocumentType(e.target.value);
    InsertPELogs(globalsettings.clientIp, "Selected the document " + e.target.value);
  }

  return (
    <div>
    {/* FB 9672 */}
      <section
        //ref={scrollTo}
        style={{
          margin: "10px 20px 20px",
        }}
      >
        <Grid container spacing={2} style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
          <Grid
            item
            xs={11}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="body1">
            {/*FB 10815*/}
            {uploadDocumentText}
            </Typography>
          </Grid>
        </Grid>

        <div>
          <Grid container spacing={3} style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "1%" }}>
            <Grid item xs={window.innerWidth <= 768 ? 12 : 4}>  {/*FB 4955*/}
              <ThemeProvider theme={theme}>
                <FormControl required fullWidth>
                  <InputLabel id="for_documenttype">Document category</InputLabel>
                  <Select
                    labelId="for_documenttype"
                    value={documentType}
                    //onChange={e => setDocumentType(e.target.value)}
                    onChange={e => SelectDocumentType(e)} // FB 4960
                    name="document_type"
                  >
                    {
                      documentCategories.map((item: string) => <MenuItem value={item}> {item} </MenuItem>) //FB 11093 Changed the case of Document
                    }
                  </Select>
                </FormControl>
              </ThemeProvider>
            </Grid>
            {/*FB 4955*/}
            <Grid item xs={window.innerWidth <= 768 ? 12 : 4} style={{ display: documentType === "other" ? "block" : "none" }}>
              <ThemeProvider theme={theme}>
                <TextField
                  label="Please specify the other document"
                  variant="standard"
                  name="other_document"
                  value={otherDocument}
                  onChange={e => setOtherDocument(e.target.value)}
                  fullWidth
                />
              </ThemeProvider>
            </Grid>
            {/*FB 4955*/}
            <Grid item xs={window.innerWidth <= 768 ? 12 : 4} >
              <Button
                variant="contained"
                component="label"
                className={styles.navigationButton}
                disabled={documentType.length > 0 ? false : true}
              >
                Choose File
                {/* FB 9671 */}
                <input
                  type="file"
                  name="document_path"
                  onChange={e => addInputDocument(e)}
                  onClick={(event) => {
                    event.currentTarget.value = ''
                  }}
                  accept="image/*,.pdf"
                  hidden
                  multiple
                />
              </Button>

              <Typography variant="subtitle2">
                (Accepted file types: pdf, jpg, png. Max.size: 6 MB)
              </Typography>
            </Grid>
			{/* FB 6025 Start */}
            <Grid item xs={4}>
              <Button
                variant="contained"
                component="label"
                className={styles.navigationButton}
                onClick={useSmartphoneClick}
                disabled={documentType.length > 0 ? false : true}
                style={{ display: window.innerWidth < 768 ? "None" : "Initial" }}
              >
                Use Smartphone
              </Button>
            </Grid>
            {/* FB 6025 End */}
          </Grid>
          <Grid container spacing={2} style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            {/*FB 4955*/}
            <Grid item xs={documentType === "other" || window.innerWidth <= 768 ? 12 : 8}>
              <span style={{ color: "red" }}>* Mandatory fields</span>
            </Grid>
          </Grid>
        </div>

        <div style={{ height: "35vh", marginBottom: "inherit" }}>
          <Grid container style={{ display: inputList.length > 0 ? "flex" : "none", alignItems: "center", justifyContent: "center" }}>
            {/*FB 4955*/}
            <Grid item xs={window.innerWidth <= 768 ? 12 : 8} style={{ marginTop: 10, height: "35vh", overflow: "hidden" }}>
              <TableContainer style={{ maxHeight: "35vh" }} >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={4} style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
                        Selected files
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontSize: "1rem" }}>Document Category</TableCell>
                      <TableCell style={{ fontSize: "1rem" }}>Name</TableCell>
                      <TableCell style={{ fontSize: "1rem" }}>Size</TableCell>
                      <TableCell style={{ fontSize: "1rem" }}>Tools</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {inputList.map((input, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>
                            {input.DocumentType === "other" ? input.OtherDocument : input.DocumentType}
                          </TableCell>
                          <TableCell>
                            {input.FileName}
                          </TableCell>
                          <TableCell>
                            {input.FileSize + " MB"}
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Delete">
                              <IconButton aria-label="delete" onClick={() => handleRemoveClick(index)} size="small">
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>)
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </div>

        <Grid container spacing={3} className={styles.flexcenter_Grid}>
          {/*FB 4955*/}
          <Grid item xs={window.innerWidth <= 768 ? 12 : 8}>
            <Button
              onClick={submitDocuments}
              variant="contained"
              id="submit"
              className={styles.navigationButton}
              style={{ display: disableSubmit ? "none" : "flex" }}
            >
              Upload to my chart
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={3} className={styles.flexend_Grid}>
          <Grid
            item
            xs={6}
            sm={4}
            md={2}
            lg={2}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*FB 4735 DK - Added provider specific path to condition*/}
            <Button
              variant="contained"
              className={styles.navigationButton}
              onClick={handleDone}
              style={{ width: 100 }}
            >
              {buttonLabel}
            </Button>
          </Grid>
        </Grid>

        <Dialog open={openDialog} disableBackdropClick fullWidth maxWidth={"xs"}>
          <DialogTitle style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
            <Typography style={{ color: "#18a2b8" }}>Uploading...</Typography>
          </DialogTitle>
          <DialogContent style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
            <CircularProgressWithLabel value={progress} />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>

      </section>
    </div>
  );
}

export default Upload;